import apiClient from "../../utils/apiClient"; // Adjust path based on your structure


export const ConsumerProfile = (uuid) => {
  return apiClient.get(`/users/consumers/profile/${uuid}`);
}

export const OrderDetails = (params) => {
    return apiClient.get('/orders/order/customer/v2', { 
        params: {
            customerUUID: params.customerUUID,
            page: params.page,
            limit: params.limit
        }
    });
};

export const TrackOrder = (orderNumber) => {
    return apiClient.get(`/users/consumers/orders/${orderNumber}/tracking`);
}

export const OrderItemDetails = (orderNumber) => {
    return apiClient.get(`/orders/order/details/${orderNumber}`);
}
